import { ReactElement } from 'react'
import {
  GetStaticPathsContext,
  GetStaticPropsContext,
  InferGetStaticPropsType
} from 'next'

import Meta from '@/components/base/Meta'
import PageBuilder from '@/components/layout/Builder'
import Layout from '@/components/layout/Layout'
import usePagePrecache from '@/hooks/usePagePrecache'
import { getPagePrecacheMedia } from '@/utils/page'

import { WPPageData, WPRoutes } from '@/types'

export default function Page(
  pageData: InferGetStaticPropsType<typeof getStaticProps>
) {
  usePagePrecache(true, getPagePrecacheMedia(pageData))

  return <PageBuilder pageData={pageData} />
}

Page.getLayout = function getLayout(page: ReactElement, pageData: WPPageData) {
  return (
    <Layout pageData={pageData}>
      <Meta pageData={pageData} />
      {page}
    </Layout>
  )
}

export async function getStaticProps({
  params
}: GetStaticPropsContext<{ routes: string[] }>) {
  const pageData = require(`@/data/pages/${params?.routes.join('/')}.json`)

  return {
    props: {
      ...pageData
    }
  }
}

export async function getStaticPaths({}: GetStaticPathsContext) {
  const routes = require('@/data/routes.json') as WPRoutes

  return {
    paths: routes.map((route) => ({
      params: { routes: route.routes.filter((item) => item !== route.locale) },
      locale: route.locale
    })),
    fallback: 'blocking' // false
  }
}
